import {BI_MODAL_BUTTONS} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {ChevronDownSmall, ChevronUpSmall} from '@wix/wix-ui-icons-common/on-stage'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useRef} from 'react'
import {HoverStyles, TextButton, TextButtonPriority} from 'wix-ui-tpa/cssVars'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {useAppActions, useAppSelector} from '../../../../../hooks/runtime'
import {getLegendItems} from '../../../../../selectors/seating/legend'
import {LegendItem} from './item'
import {classes} from './legend.st.css'

export const Legend = () => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()
  const {seatingMapButtonClick} = useAppActions()
  const {getFormattedMoney, getTicketPriceText} = useCurrencyFormatter()
  const [expanded, setExpanded] = React.useState(false)
  const [scrollable, setScrollable] = React.useState(false)
  const scrollableTimeout = useRef<NodeJS.Timeout>()

  const legendItems = useAppSelector(state => getLegendItems(state, t, {getTicketPriceText, getFormattedMoney}))

  const handleClick = () => {
    clearTimeout(scrollableTimeout.current)

    seatingMapButtonClick(expanded ? BI_MODAL_BUTTONS.HIDE_PRICES : BI_MODAL_BUTTONS.SHOW_PRICES)

    const willBeExpanded = !expanded

    setExpanded(willBeExpanded)

    if (!willBeExpanded) {
      setScrollable(false)
    } else {
      scrollableTimeout.current = setTimeout(() => {
        setScrollable(true)
      }, 330)
    }
  }

  return (
    <div
      className={classNames(classes.container, {
        [classes.desktopContainer]: !isMobile,
      })}
      onClick={handleClick}
      onWheelCapture={e => e.stopPropagation()}
      data-hook={DH.PRICES_LEGEND}
    >
      <TextButton
        priority={TextButtonPriority.secondary}
        hoverStyle={HoverStyles.underline}
        className={classes.label}
        suffixIcon={expanded ? <ChevronDownSmall /> : <ChevronUpSmall />}
        tabIndex={-1}
      >
        {expanded ? t('seatings_legend_title_expanded') : t('seatings_legend_title')}
      </TextButton>
      <ul
        aria-hidden={!expanded}
        className={classNames(classes.list, {[classes.listExpanded]: expanded, [classes.listScrollable]: scrollable})}
      >
        {legendItems.map(({color, price, name}, index) => (
          <LegendItem key={index} color={color} price={price} name={name} />
        ))}
      </ul>
    </div>
  )
}
